import { render, staticRenderFns } from "./PricePerUnit.vue?vue&type=template&id=1b260ade"
import script from "./PricePerUnit.vue?vue&type=script&lang=js"
export * from "./PricePerUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports